const style = {
  display: 'flex',
  alignItems: 'stretch',
  ['& > *']: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '3rem',
    padding: '0 0.5rem',
    borderBottom: 'solid 0.2rem #6666aa',
    ['& > img']: {
      height: '1.6rem',
    },
  },
  ['& > *[data-invalid="1"] > img']: {
    filter: 'invert(59%) sepia(1%) saturate(1979%) hue-rotate(32deg) brightness(93%) contrast(76%)',
  },
  ['& > *[data-present="1"]']: {
    backgroundColor: '#eeeeff',
  },
  ['& > *:not([data-present="1"]):not([data-invalid="1"])']: {
    cursor: 'pointer',
    ['&:hover']: {
      backgroundColor: '#eeeeff',
    },
  },
};

export type PagerProps = Readonly<{
  onChange: (page: number) => void | Promise<void>;
  page: number;
  perPage: number;
  className?: string;
}>;

const Pager = (props: PagerProps) => {
  const minPage = Math.max(props.page - 3, 1);
  const maxPage = Math.min(props.page + 3, props.perPage);
  const linkPages = Array(maxPage - minPage + 1).fill(null).map((_, index) => minPage + index);

  const onChange = (targetPage: number) => {
    if (targetPage !== props.page && targetPage > 0 && targetPage <= props.perPage) {
      props.onChange(targetPage);
    }
  };

  return <div css={style} className={props.className}>
    <div onClick={() => onChange(props.page - 1)} data-invalid={props.page <= 1}>
      <img src='/image/icon/chevron-double-left.svg' />
    </div>
    {linkPages.map(
      (linkPage, index) => (
        <div onClick={() => onChange(linkPage)} data-present={linkPage === props.page ? '1' : '0'} key={index}>{linkPage}</div>
      )
    )}
    <div onClick={() => onChange(props.page + 1)} data-invalid={props.page >= props.perPage}>
      <img src='/image/icon/chevron-double-right.svg' />
    </div>
  </div>;
};

export default Pager;
